import { navigate } from 'gatsby';
import { AppDispatch } from '../../app/redux/configureStore';
import { AUTH_LEVEL } from '../../app/services/authTypes';
import { User } from '../../app/user/profile/profileUtils';

type StatusColour = {
  background: string;
  fill: string;
  stroke: string;
  border: string;
};

/**
 * Return an object with colour classes depending on the profile percentage completion.
 * @param percentage number
 * @returns
 */
export const getUserProfileStatusColoursByPercentage = (percentage: number): StatusColour => {
  let output: StatusColour;
  switch (true) {
    case percentage >= 0 && percentage < 30:
      output = {
        background: 'bg-danger',
        fill: 'fill-danger-200',
        stroke: 'stroke-danger',
        border: 'border-danger'
      };
      break;
    case percentage >= 30 && percentage < 75:
      output = {
        background: 'bg-warning-700',
        fill: 'fill-banana-200',
        stroke: 'stroke-warning-700',
        border: 'warning-700'
      };
      break;
    case percentage >= 75:
      output = {
        background: 'bg-primary',
        fill: 'fill-primary-200',
        stroke: 'stroke-primary-700',
        border: 'primary-700'
      };
      break;
    default:
      output = {
        background: 'bg-danger-1100',
        fill: 'fill-mint-200',
        stroke: 'stroke-danger-1100',
        border: 'danger-1100'
      };
      break;
  }

  return output;
};

/**
 * Return display name for the logged in user.
 * @param user User
 * @param authLevel AUTH_LEVEL
 * @returns string
 */
export const getUserProfileDisplayName = (user: User, authLevel: AUTH_LEVEL): string => {
  let name: any = '';
  if (user && user.firstName) {
    name = authLevel === AUTH_LEVEL.FULL ? `${user.firstName} ${user.lastName ?? ''}` : `${user.firstName}`;
  }
  return name;
};

/**
 * Returns if a User has completed their profile
 * @param user User
 * @returns boolean;
 */
export const isUserProfileComplete = (user: User) => user?.profileCompletion === 100;

